import { render, staticRenderFns } from "./SelectedBusiness.vue?vue&type=template&id=36b81ade&"
import script from "./SelectedBusiness.vue?vue&type=script&lang=js&"
export * from "./SelectedBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports